/**
 * Product Form Components
 *
 */
var currentVariant = null;
window.isSubscription = false;
window.isOnetime = true;

if (document.querySelector('[data-currentJson]') != null) {
  currentVariant = JSON.parse(document.querySelector('[data-currentJson]').innerHTML);
}
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  async onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    // Added / Remove dummy product for shipping profile
    // if (this.querySelector('[name="properties[_product_type]"]') != null && this.querySelector('[name="properties[_product_type]"]').value != 'gift-certi') {
    //   await this._removeDummyProduct();
    //   await this._addDummyProduct();
    // }

    for (let item of window.globalVariables.cart.items) {
      if (item.properties['_coffee_type'] == 'gift') {
        var header1 = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        };
        await fetch('/cart/clear.js', header1)
          .then(data => {
            console.log(data, 'data')
          }).catch(e => {
            console.log(e);
          });
      }
    }
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form))
    });
    if (document.querySelector('[data-source-attribute]') != null) {
      document.querySelector('[data-source-attribute]').remove();
		const additionalCheckoutButtons = document.getElementById('additional-checkout-buttons');
		if ( additionalCheckoutButtons ) {
			additionalCheckoutButtons.innerHTML = "";
		}
    }
    await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        localStorage.removeItem('email');
        localStorage.removeItem('fname')
        localStorage.removeItem('lname')
        localStorage.removeItem('address1')
        localStorage.removeItem('address2')
        localStorage.removeItem('state')
        localStorage.removeItem('zip')
        localStorage.removeItem('country')
        localStorage.removeItem('phone')
        localStorage.removeItem('city')

        if (document.querySelector('#PopupModal-quickshop')) {
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        this.cartElement.getCartData('open_drawer');
        if (document.querySelector('[name="properties[_change_address]"]') != null) {
          document.querySelector('[name="properties[_change_address]"]').value = true
        }
        setTimeout(() => {
          if (document.querySelector('[data-source-attribute]') == null) {
            var po = document.createElement('script');
            po.type = 'text/javascript';
            po.async = true;
            po.setAttribute('data-source-attribute', 'shopify.dynamic_checkout.cart.init')
            po.src = 'https://cdn.shopify.com/shopifycloud/payment-sheet/assets/latest/dynamic-checkout-cart.en.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(po, s);
          }
        }, 1000);

        if (qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  async _addDummyProduct() {
    let flag = false;
    for (const item of window.globalVariables.cart.items) {
      if (item.properties.product_type == 'dummy') {
        flag = true;
      }
    }
    if (!flag) {
      var header = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      };

      let obj =
      {
        quantity: 1,
        id: 42356455669999,
        properties: {
          'product_type': 'dummy'
        }
      }
      var header = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      };

      await fetch('/cart/add.js', header)
        .then(data => {
        }).catch(e => {
          console.log(e);
        });
    }
  }

  async _removeDummyProduct() {
    let flag = false;
    for (const item of window.globalVariables.cart.items) {
      if (item.properties.product_type == 'dummy') {
        flag = true;
      }
    }
    if (flag) {
      var header = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      };

      let obj = {
        quantity: 0,
        id: 42356455669999
      }
      var header = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(obj),
      };

      await fetch('/cart/update.js', header)
        .then(data => {
        }).catch(e => {
          console.log(e);
        });
    }

  }
  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if (action == 'decrease' && currentQty <= 1) {
      return false;
    } else if (action == 'decrease') {
      finalQty = currentQty - 1;
    } else {
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
    // console.log(currentTarget.closest('[data-product-container]').querySelector('[data-currentprice]').getAttribute('data-currentprice'))
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.prouduct_json = JSON.parse(this.form.querySelector('[data-productJSON]').innerHTML);

    this.variantPicker = this.dataset.type;

    if (this.formType == 'product-page') this.onVariantChange();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    this.setCurrentVariant();
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
    } else {
      if (this.formType == 'grid') {
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        currentVariant = this.currentVariant = variant;
        setTimeout(() => {
          window.showSellingOffer();
        }, 500);
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if (this.closest('[data-upsell_item]') != null && this.closest('[data-upsell_item]').querySelector('[data-currentprice]') != null) {
      this.closest('[data-upsell_item]').querySelector('[data-currentprice]').innerHTML = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    }
    if (!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');

    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement && currentVariant.compare_at_price > currentVariant.price) {
      comparePriceElement.innerHTML = compare_price;
      let discount_price = parseFloat(((currentVariant.compare_at_price) - (currentVariant.price)) / currentVariant.compare_at_price) * 100;
      container.querySelector('[data-save_percentage]').innerHTML = `save ${parseInt(discount_price)}%`;
      container.querySelector('[data-save_percentage]').classList.remove('d-none');
      container.querySelector('[data-save_percentage]').classList.add('text-primary');
      container.querySelector('[data-currentprice]').classList.add('text-primary');
      comparePriceElement.classList.remove('d-none');
    } else if (comparePriceElement) {
      comparePriceElement.classList.add('d-none');
      container.querySelector('[data-currentprice]').classList.remove('text-primary');
      container.querySelector('[data-save_percentage]').classList.add('d-none');
    }

    for (let [i, option] of this.prouduct_json.options.entries()) {
      if (document.querySelector(`[data-option${i + 1}_value]`) != null) {
        document.querySelector(`[data-option${i + 1}_value]`).innerHTML = currentVariant.options[i]
      }
      if (document.querySelector(`[data-option_selected_value_${i + 1}]`) != null) {
        document.querySelector(`[data-option_selected_value_${i + 1}]`).innerHTML = currentVariant.options[i]
      }
    }

    let metafields = [];
    document.querySelectorAll('[data-variants-metafield-json]').forEach(variant => {
      metafields.push(JSON.parse(variant.innerHTML));
    });
    let specification_html = "";
    for (var variant of metafields) {
      if (variant.variant_id == currentVariant.id) {
        var count = 0;
        for (let [key, value] of Object.entries(variant['variant_metafields'])) {
          if (document.querySelector(`[data-metafield${count + 1}_value]`) != null) {
            document.querySelector(`[data-metafield${count + 1}_value]`).innerHTML = value;
          }
          count++;
        }
      }
    };
    for (let [i, option] of this.prouduct_json.options.entries()) {
      if (document.querySelector(`[data-option${i + 1}_value]`) != null) {
        document.querySelector(`[data-option${i + 1}_value]`).innerHTML = currentVariant.options[i]
      }
      if (document.querySelector(`[data-option_selected_value_${i + 1}]`) != null) {
        document.querySelector(`[data-option_selected_value_${i + 1}]`).innerHTML = currentVariant.options[i]
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == 'grid') {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_image.id;
      let imageSlide = document.querySelector(`.product--image[data-imageID="${imageID}"]`);
      if (this.formType == 'quickshop') {
        imageSlide = document.querySelector(`.quickshop-slider .product--image[data-imageID="${imageID}"]`);
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }


    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option' + option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if (!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
    let productJson = JSON.parse(document.querySelector('[data-product_options]'));

  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('disable');
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.classList.remove('disable');
      if (this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;;
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if (colorSwatchContainer) {
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);

window.changePriceAccoringCountry = function () {
  var qty = parseInt(document.querySelector('[data-qty-container] input').value);
  var coffe_type = document.querySelector('[data-coffee_type]').getAttribute('data-coffee_type');
  if (coffe_type == 'coffee' && document.querySelector('[data-type="variant-radios"] .swatch [name="Bag Size"]') != null) {
    document.querySelectorAll('[data-type="variant-radios"] .swatch [name="Bag Size"]:checked').forEach(ele => {

      var bagsize = ele.value;
      var selectedSubscriptionType = "";

      if (bagsize == '1lb') {
        selectedSubscriptionType = 'myself'
      } else {
        selectedSubscriptionType = 'office'
      }
      var maxDiscountQty = 0;
      if (qty > 2) {
        maxDiscountQty = 3;
      } else {
        maxDiscountQty = qty;
      }
      var discount = 0;

      if (window.currentCountry == 'IN' || window.currentCountry == 'US') {
        if (bagsize == '1lb' || bagsize == '5lb') {
          discount = parseFloat(window.globalVariables.settings[`discount_bag_${selectedSubscriptionType}_${maxDiscountQty}`]);
        } else {
          discount = 0;
        }
      } else if (window.currentCountry == 'CA') {
        discount = 5;
      }

      var current_price = currentVariant.price;
      current_price = (current_price * qty).toFixed(2);
      var subscription_price = current_price - (current_price * (discount / 100));
      var normal_price = current_price - (current_price * (0 / 100));

      if (document.querySelector('[data-price-subsave]') != null) {
        document.querySelector('[data-price-subsave]').innerHTML = Shopify.formatMoney(subscription_price, window.globalVariables.money_format)
      }
      if (document.querySelector('[data-price-subsave]') != null) {
        document.querySelector('[data-price-onetime]').innerHTML = Shopify.formatMoney(normal_price, window.globalVariables.money_format)
      }

      if (window.isSubscription == false) {
        discount = 0;
      }

      var final_price = current_price - (current_price * (discount / 100));

      if (document.querySelector('[data-price-mutation-watcher]') != null) {
        document.querySelector('[data-price-mutation-watcher]').removeAttribute('data-price-mutation-watcher')
      }
      document.querySelector('[data-currentPrice]').innerHTML = Shopify.formatMoney(final_price, window.globalVariables.money_format)
    });
  } else {
    // var discount=0;
    // if(window.currentCountry == 'CA'){
    //   discount=5;
    // }
    // var current_price=currentVariant.price;
    // current_price=(current_price*qty).toFixed(2)
    // var final_price=current_price-(current_price*(discount/100));
    // if(document.querySelector('[data-price-mutation-watcher]') != null){
    //   document.querySelector('[data-price-mutation-watcher]').removeAttribute('data-price-mutation-watcher')
    // }
    // document.querySelector('[data-currentPrice]').innerHTML=Shopify.formatMoney(final_price,window.globalVariables.money_format)
    var discount = 0;
    if (coffe_type == 'tea') {
      discount = 5;
    }
    var current_price = currentVariant.price;
    current_price = (current_price * qty).toFixed(2);
    var subscription_price = current_price - (current_price * (discount / 100));
    var normal_price = current_price - (current_price * (0 / 100));

    if (document.querySelector('[data-price-subsave]') != null) {
      document.querySelector('[data-price-subsave]').innerHTML = Shopify.formatMoney(subscription_price, window.globalVariables.money_format)
    }
    if (document.querySelector('[data-price-subsave]') != null) {
      document.querySelector('[data-price-onetime]').innerHTML = Shopify.formatMoney(normal_price, window.globalVariables.money_format)
    }
    if (window.isSubscription == false) {
      discount = 0;
    }

    var final_price = current_price - (current_price * (discount / 100));

    if (document.querySelector('[data-price-mutation-watcher]') != null) {
      document.querySelector('[data-price-mutation-watcher]').removeAttribute('data-price-mutation-watcher')
    }
    document.querySelector('[data-currentPrice]').innerHTML = Shopify.formatMoney(final_price, window.globalVariables.money_format)
  }

}

if (currentVariant != null) {
  // setInterval(() => {
  //   window.changePriceAccoringCountry();
  // }, 100);
}

{
	const variantIdObserver = window.MutationObserver ? new window.MutationObserver( entries => {
		entries.forEach( entry => {
			if ( 'attributes' !==  entry.type
				|| 'value' !==  entry.attributeName
				|| 'id' !==  entry.target.name
			) {
				return;
			}

			/*
			 * Based on example from https://goodsubscription.agency/products/course-academy?variant=41238618374203.
			 */
			const subscriptionPrice = document.getElementById( 'subscription-price' );
			const onetimePrice = document.getElementById( 'one-time-price' );

			let sellingPlan = null;

			const sellingPlanInput = document.querySelector('input[name="selling_plan"]');

			if ( currentVariant
				&& currentVariant.selling_plan_allocations
				&& currentVariant.selling_plan_allocations[0]
			) {
				sellingPlan = currentVariant.selling_plan_allocations[0];

				if ( sellingPlanInput && sellingPlanInput.value ) {
					sellingPlan = currentVariant.selling_plan_allocations.find( plan => plan.selling_plan_id === window.parseInt( sellingPlanInput.value ) );
				}
			}

			if ( sellingPlan
				&& onetimePrice
			) {
				onetimePrice.innerHTML = Shopify.formatMoney( sellingPlan.compare_at_price, window.globalVariables.money_format );
			}

			if ( sellingPlan
				&& subscriptionPrice
			) {
				subscriptionPrice.innerHTML = Shopify.formatMoney( sellingPlan.per_delivery_price, window.globalVariables.money_format );
			}
		} );
	} ) : null;

	const sellingPlanObserver = window.MutationObserver ? new window.MutationObserver( entries => {
		entries.forEach( entry => {
			if ( 'attributes' !==  entry.type
				|| 'value' !==  entry.attributeName
				|| 'selling_plan' !==  entry.target.name
			) {
				return;
			}

			let sellingPlan = null;

			if ( currentVariant
				&& currentVariant.selling_plan_allocations
				&& currentVariant.selling_plan_allocations[0]
			) {
				sellingPlan = currentVariant.selling_plan_allocations[0];

				if ( entry.target && entry.target.value ) {
					sellingPlan = currentVariant.selling_plan_allocations.find( plan => plan.selling_plan_id === window.parseInt( entry.target.value ) );
				}
			}

			const subscriptionPrice = document.getElementById( 'subscription-price' );
			const onetimePrice = document.getElementById( 'one-time-price' );
			const selectSellingPlan = document.querySelector( 'select[name="selling_plan"]' );
			const inputPurchaseOptionsSubscriptionOption = document.querySelector( 'input[name="purchase_options"][value="subscription-option"]' );
			const inputPurchaseOptionsOnetimeOption = document.querySelector( 'input[name="purchase_options"][value="onetime-option"]' );
			const gsaAccordionContent = document.querySelector( '.gsa-accordion-content' );
			const frequencyInputWrap = document.querySelector( '.frequency-input-wrap' );

			if ( sellingPlan
				&& onetimePrice
			) {
				onetimePrice.innerHTML = Shopify.formatMoney( sellingPlan.compare_at_price, window.globalVariables.money_format );
			}

			if ( sellingPlan
				&& subscriptionPrice
			) {
				subscriptionPrice.innerHTML = Shopify.formatMoney( sellingPlan.per_delivery_price, window.globalVariables.money_format );
			}

			if ( sellingPlan
				&& sellingPlan.selling_plan_id
				&& entry.target.value
				&& selectSellingPlan
			) {
				selectSellingPlan.value = sellingPlan.selling_plan_id;

				if ( inputPurchaseOptionsSubscriptionOption ) {
					inputPurchaseOptionsSubscriptionOption.checked = true;
				}

				if ( inputPurchaseOptionsOnetimeOption ) {
					inputPurchaseOptionsOnetimeOption.checked = false;
				}

				if ( gsaAccordionContent
					&& gsaAccordionContent.classList
				) {
					gsaAccordionContent.classList.add( 'open' );
				}

				if ( frequencyInputWrap
					&& frequencyInputWrap.style
				) {
					frequencyInputWrap.style.display = 'block';
				}

			} else if ( selectSellingPlan ) {
				selectSellingPlan.value = '';

				if ( inputPurchaseOptionsSubscriptionOption ) {
					inputPurchaseOptionsSubscriptionOption.checked = false;
				}

				if ( inputPurchaseOptionsOnetimeOption ) {
					inputPurchaseOptionsOnetimeOption.checked = true;
				}

				if ( gsaAccordionContent
					&& gsaAccordionContent.classList
				) {
					gsaAccordionContent.classList.remove( 'open' );
				}

				if ( frequencyInputWrap
					&& frequencyInputWrap.style
				) {
					frequencyInputWrap.style.display = 'none';
				}
			}

			const selectedPurchaseOption = document.querySelector( 'input[name="purchase_options"]:checked' );
			const alternateCurrentPrice = document.querySelector( '.alternate-current-price' );

			if ( sellingPlan && selectedPurchaseOption && alternateCurrentPrice ) {
				switch ( selectedPurchaseOption.value ) {
					case 'subscription-option':
						alternateCurrentPrice.innerHTML = Shopify.formatMoney( sellingPlan.per_delivery_price, window.globalVariables.money_format );
						break;
					case 'onetime-option':
						alternateCurrentPrice.innerHTML = Shopify.formatMoney( sellingPlan.compare_at_price, window.globalVariables.money_format );
						break;
				}
			}
		} );
	} ) : null;

	const productFormObserver = window.MutationObserver ? new window.MutationObserver( entries => {
		entries.forEach( entry => {
			let sellingPlan = entry.target.querySelector( 'input[name="selling_plan"]' );

			if ( ! sellingPlan ) {
				sellingPlan = document.createElement( 'input' );
				sellingPlan.setAttribute( 'type', 'hidden' );
				sellingPlan.setAttribute( 'id', 'selling_plan' );
				sellingPlan.setAttribute( 'name', 'selling_plan' );
				sellingPlan.setAttribute( 'class', 'gsa_selling_plan' );
				sellingPlan.setAttribute( 'value', '' );
				entry.target.appendChild( sellingPlan );
			}

			if ( sellingPlanObserver ) {
				sellingPlanObserver.disconnect();
				sellingPlanObserver.observe( sellingPlan, { attributes: true, childList: false, subtree: false } );
			}
		} );
	} ) : null;

	const moveSubscribeWidget = () => {
		const widget = document.querySelector( '[id^="shopify-block-good_subscription_upsell_subscribe_and_save_widget_"]' );
		const addToCart = document.querySelector( '.quantity-wrapper-container:has(.add-to-cart-btn)' );

		if ( ! widget ) {
			return;
		}

		if ( widget && addToCart && addToCart.parentNode ) {
			addToCart.parentNode.insertBefore( widget, addToCart );
		}

		const variantSelector = document.querySelector('[name="id"]');

		if ( variantSelector && variantIdObserver ) {
			variantIdObserver.observe( variantSelector, { attributes: true, childList: false, subtree: false } );
		}

		if ( addToCart && addToCart.parentNode ) {

			if ( productFormObserver ) {
				productFormObserver.observe( addToCart.parentNode, { attributes: false, childList: true, subtree: false } );
			}

			let sellingPlan = addToCart.parentNode.querySelector( 'input[name="selling_plan"]' );

			if ( ! sellingPlan ) {

				sellingPlan = document.createElement( 'input' );
				sellingPlan.setAttribute( 'type', 'hidden' );
				sellingPlan.setAttribute( 'id', 'selling_plan' );
				sellingPlan.setAttribute( 'name', 'selling_plan' );
				sellingPlan.setAttribute( 'class', 'gsa_selling_plan' );
				sellingPlan.setAttribute( 'value', '' );
				addToCart.parentNode.appendChild( sellingPlan );
			}

			if ( sellingPlanObserver ) {
				sellingPlanObserver.disconnect();
				sellingPlanObserver.observe( sellingPlan, { attributes: true, childList: false, subtree: false } );
			}
		}

		const priceWrapper = document.querySelector( '.price-wrapper' );

		if ( priceWrapper ) {
			priceWrapper.insertAdjacentHTML( 'afterend', '<div class="alternate-price-wrapper mt-2"><span class="alternate-current-price h5"></span></div>' );
			priceWrapper.classList.add( 'd-none' );
		}
	};

	if (
		'complete' === document.readyState ||
		'interactive' === document.readyState
	) {
		moveSubscribeWidget();
	} else {
		document.documentElement.ownerDocument.addEventListener(
			'DOMContentLoaded',
			moveSubscribeWidget
		);
	}

	const productFormPriceObserver = window.MutationObserver ? new window.MutationObserver( entries => {
		entries.forEach( entry => {
			if ( 'attributes' === entry.type
				&& 'value' === entry.attributeName
			) {
				const target = entry.target.closest( '[name]' );

				if ( ! target ) {
					/*
					console.log( {
						entry,
					} );
					*/
					return;
				}

				const form = entry.target && entry.target.form ? entry.target.form : target.form;

				if ( ! form
					|| ! form.querySelector
				) {
					/*
					console.log( {
						entry,
						target,
					} );
					*/
					return;
				}

				const productDataElement = form.querySelector('[data-productjson]');
				const variantDataElement = form.querySelector('[data-variantjson]');

				if ( ! productDataElement
					|| ! variantDataElement
				) {
					/*
					console.log( {
						entry,
						target,
						productDataElement,
						variantDataElement,
					} );
					*/
					return;
				}

				let productData = false;
				let variantData = false;
				let variant = false;
				let sellingPlan = false;
				let price = false;

				try {
					productData = window.JSON.parse( productDataElement.innerText );
					variantData = window.JSON.parse( variantDataElement.innerText );
				} catch ( error ) {
//					console.log( error );
				}

				const variantId = 'id' === target.name ? target.value : form.querySelector('[name="id"]')?.value;
				const sellingPlanId = 'selling_plan' === target.name ? target.value : form.querySelector('[name="selling_plan"]')?.value;

				if ( variantData
					&& variantData.find
					&& variantId
				) {
					variant = variantData.find( item => item.id === window.parseInt( variantId ) );
				}

				if ( variant
					&& variant.selling_plan_allocations
					&& sellingPlanId
				) {
					sellingPlan = variant.selling_plan_allocations.find( item => item.selling_plan_id === window.parseInt( sellingPlanId ) );
				}

				if ( sellingPlan
					&& sellingPlan.price
				) {
					price = sellingPlan.price;
				} else if ( variant
					&& variant.price
				) {
					price = variant.price;
				}

				if ( ! price ) {
					return;
				}


				let alternateCurrentPrice = document.querySelector( '.alternate-current-price' );

				if ( ! alternateCurrentPrice ) {

					const priceWrapper = document.querySelector( '.price-wrapper' );

					if ( priceWrapper ) {

						priceWrapper.insertAdjacentHTML( 'afterend', '<div class="alternate-price-wrapper mt-2"><span class="alternate-current-price h5"></span></div>' );
						priceWrapper.classList.add( 'd-none' );

						alternateCurrentPrice = document.querySelector( '.alternate-current-price' );
					}
				}


				if ( alternateCurrentPrice ) {
					alternateCurrentPrice.innerHTML = Shopify.formatMoney( price, window.globalVariables.money_format );
				}


				const oneTimePrice = document.querySelector( '[data-price-onetime]' );

				if ( oneTimePrice
					&& variant
					&& variant.price
				) {
					oneTimePrice.innerHTML = Shopify.formatMoney( variant.price, window.globalVariables.money_format );
				}

				const subSavePrice = document.querySelector( '[data-price-subsave]' );
				const plansDropdown = document.querySelector( '[data-plans-dropdown]' );

				if ( subSavePrice
					&& plansDropdown
					&& plansDropdown.value
					&& variant
					&& variant.selling_plan_allocations
				) {
					sellingPlan = variant.selling_plan_allocations.find( item => item.selling_plan_id === window.parseInt( plansDropdown.value ) );
					subSavePrice.innerHTML = Shopify.formatMoney( sellingPlan.price, window.globalVariables.money_format );
				}
			}
		} );
	} ) : null;

	const updatePrice = () => {
		window.Array.prototype.forEach.call( document.querySelectorAll( '.product-form form' ), productForm => {

			if ( productForm && productFormPriceObserver ) {
				productFormPriceObserver.observe( productForm, { attributes: true, childList: true, subtree: true } );
			}
		} );
	};

	if (
		'complete' === document.readyState ||
		'interactive' === document.readyState
	) {
		updatePrice();
	} else {
		document.documentElement.ownerDocument.addEventListener(
			'DOMContentLoaded',
			updatePrice
		);
	}
}
